@for (folder of folders; track folder.id) {
  <div class="folder-menu-item" [class.simple]="simpleMode" (click)="selectFolder($any(folder), $event)">
    <div class="folder-icon-container">
      <app-svg src="/assets/icons/folder.svg"></app-svg>
    </div>
    <span>
      <span [appTooltip]="folder.title">{{ folder.title }}</span>
      @if (!simpleMode) {
        <div class="meta">
          Folder ⋅ {{ folderGalleryCount[folder.id] }}
          @if (folderGalleryCount[folder.id] !== 1) {
            Galleries
          } @else {
            Gallery
          }
        </div>
      }
    </span>
    <app-svg src="/assets/icons/stroke/arrow-right.svg"></app-svg>
  </div>
}
@for (item of galleryTree; track item.gallery.id) {
  <div
    class="tree-item"
    [class.simple]="simpleMode"
    [appTooltip]="
      blockGallerySelection && !folderMode
        ? 'Galleries that contain Sub-Galleries can only be moved into folders.'
        : undefined
    "
  >
    <div
      class="gallery main-gallery"
      [class.disabled]="item.disabled || blockGallerySelection"
      [class.active]="item.gallery.id === currentGallery?.id"
      (click)="selectGallery(item.gallery, $event)"
      [id]="item.gallery.id"
    >
      @if (item.gallery.teaser.uuid) {
        <img
          [src]="item.gallery | galleryTeaserUrl: 56"
          [style.object-position]="
            item.gallery.teaser.uuid === item.gallery.cover.uuid ? item.gallery.cover.position : undefined
          "
          alt=""
          class="gallery-teaser-asset"
        />
      } @else {
        <div class="gallery-teaser-asset"></div>
      }
      <span>
        <span [appTooltip]="item.gallery.name || item.gallery.title">{{
          item.gallery.name || item.gallery.title || 'Untitled'
        }}</span>
        @if (!simpleMode) {
          <div class="meta">
            Gallery ⋅ {{ item.gallery.total_assets_count }}
            @if (item.gallery.total_assets_count !== 1) {
              Assets
            } @else {
              Asset
            }
          </div>
        }
      </span>
      @if (cta) {
        <button
          appButton
          name="finder-cta"
          location="finder-content"
          color="primary"
          size="1"
          spacing="3"
          height="0-5"
          shape="round"
          [class.loading]="loading === item.gallery.id"
        >
          <span [class.hidden-text]="loading === item.gallery.id">{{ cta }}</span>
          @if (loading === item.gallery.id) {
            <app-loading-indicator color="white" size="smaller" class="button-loading-indicator">
            </app-loading-indicator>
          }
        </button>
      }
      @if (!cta) {
        @if (item.gallery.id === currentGallery?.id) {
          <app-svg src="/assets/icons/check-filled.svg"></app-svg>
        }
        @if (item.gallery.id !== currentGallery?.id && !blockGallerySelection) {
          <app-svg src="/assets/icons/check-empty.svg"></app-svg>
        }
      }
    </div>
    <div class="sub-galleries">
      @for (subGallery of item.children; track subGallery.id) {
        <div
          class="gallery sub-gallery"
          [id]="subGallery.id"
          [class.disabled]="item.disabled || blockGallerySelection"
          [class.active]="subGallery.id === currentGallery?.id"
          (click)="selectGallery(subGallery, $event)"
        >
          <div class="sub-gallery-line"></div>
          @if (subGallery.teaser.uuid) {
            <img
              [src]="subGallery | galleryTeaserUrl: 56"
              [style.object-position]="
                subGallery.teaser.uuid === subGallery.cover.uuid ? subGallery.cover.position : undefined
              "
              alt=""
              class="gallery-teaser-asset"
            />
          }
          @if (!subGallery.teaser.uuid) {
            <div class="gallery-teaser-asset"></div>
          }
          <span>
            <span [appTooltip]="subGallery.name || subGallery.title">{{
              subGallery.name || subGallery.title || 'Untitled'
            }}</span>
            @if (!simpleMode) {
              <div class="meta">
                Sub-Gallery ⋅ {{ subGallery.total_assets_count }}
                @if (subGallery.total_assets_count !== 1) {
                  Assets
                } @else {
                  Asset
                }
              </div>
            }
          </span>
          @if (cta) {
            <button
              appButton
              name="finder-cta"
              location="finder-content"
              color="primary"
              size="1"
              spacing="3"
              height="0-5"
              shape="round"
              [class.loading]="loading === subGallery.id"
            >
              <span [class.hidden-text]="loading === subGallery.id">{{ cta }}</span>
              @if (loading === subGallery.id) {
                <app-loading-indicator color="white" size="smaller" class="button-loading-indicator">
                </app-loading-indicator>
              }
            </button>
          }
          @if (!cta) {
            @if (subGallery.id === currentGallery?.id) {
              <app-svg src="/assets/icons/check-filled.svg"></app-svg>
            }
            @if (subGallery.id !== currentGallery?.id && !blockGallerySelection) {
              <app-svg src="/assets/icons/check-empty.svg"></app-svg>
            }
          }
        </div>
      }
    </div>
  </div>
}
